import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography
} from "@mui/material";

function TodayListBox({ title, items = [], loading }) {

  if (!loading && (!items || items.length === 0)) {
    return null;
  }

  return (
    <Card
      sx={{
        mt: 3,
        borderRadius: 2
      }}
    >
      <CardContent>
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: "17px",
            color: "#0b1f4d",
            mb: 2
          }}
        >
          {title}
        </Typography>


        {loading && (
          <Typography variant="body2">
            Loading...
          </Typography>
        )}


        {!loading &&
          items.map((item, index) => (
            <Box
              key={index}
              sx={{
                width: "100%",
                border: "1px solid #e0e0e0",
                borderRadius: 1,
                px: 2,
                py: 1.2,
                mb: 1,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: "#fafafa"
              }}
            >
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: 500
                }}
              >
                {item.label}
              </Typography>

              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: 700
                }}
              >
                {item.count}
              </Typography>
            </Box>
          ))}
      </CardContent>
    </Card>
  );
}

export default TodayListBox;
